import axios from "axios";
import { Component } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import CommonToast from "./Toaster/CommonToast";
import CommonLoader from "./loaderComponent/CommonLoader";

export default class PurchaseOrderView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      projects: [],
      billingAddresses: [],
      dispatchAddresses: [],
      items: [],
      poNumber: "",
      poDate: "",
      customerId: "",
      projectId: "",
      billingAddressId: "",
      dispatchAddressId: "",
      status: "draft",
      customersDispatchAddress: [],
      customersBillingAddress: [],
      poItems: [
        {
          serialNumber: 1,
          itemId: "",
          hsnCode: "",
          uom: "",
          quantity: "",
          rate: "",
          taxableValue: 0,
          gstValue: 0,
          totalValue: 0,
          pendingQuantity: 0,
        },
      ],
      loading: false,
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      color: "",
      isEdit: false,
      poId: null,
      showLoading: true
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await this.fetchCustomers();
    await this.fetchItems();

    const poId = this.props.match?.params?.id;
    if (poId) {
      this.setState({ isEdit: true, poId });
      await this.fetchPurchaseOrder(poId);

      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    } else {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      } else {
        this.setState({ loading: false });
      }
    }
  }

  // componentDidMount() {
  //   this.fetchCustomers();
  //   this.fetchItems().then(() => {
  //     const poId = this.props.match?.params?.id;
  //     if (poId) {
  //       this.setState({ isEdit: true, poId });
  //       this.fetchPurchaseOrder(poId);
  //     }
  //   });
  //   setTimeout(() => {
  //     this.setState({ loading: false })
  //   }, 1000)
  // }

  fetchCustomersBillingAddress = async (customerId) => {
    try {
      const res = await axios.get(`/address/${customerId}/c/b`);
      this.setState({ customersBillingAddress: res.data });
    } catch (error) {
      console.error("Error fetching billing address:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };


  fetchCustomersDispatchAddress = async (customerId) => {
    try {
      const res = await axios.get(`/address/${customerId}/c/d`);
      this.setState({ customersDispatchAddress: res.data });
    } catch (error) {
      console.error("Error fetching dispatch address:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };


  fetchCustomers = async () => {
    try {
      const res = await axios.get("/customer");
      this.setState({ customers: res.data });
    } catch (error) {
      console.error("Failed to fetch customers:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };

  fetchProjects = async (customerId) => {
    try {
      const res = await axios.get(`/project/customer/${customerId}`);
      this.setState({ projects: res.data });
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };


  fetchAddresses = async (customerId) => {
    try {
      const res = await axios.get(`/address?customerId=${customerId}`);
      const billingAddresses = res.data.filter((a) => a.type === "billing");
      const dispatchAddresses = res.data.filter((a) => a.type === "dispatch");

      this.setState({
        billingAddresses,
        dispatchAddresses,
      });
    } catch (error) {
      console.error("Error fetching addresses:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };


  fetchItems = async () => {
    try {
      const res = await axios.get("/items");
      this.setState({ items: res.data });
    } catch (error) {
      console.error("Error fetching items:", error);
    } finally {
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      }
    }
  };


  // fetchPurchaseOrder = (id) => {
  //   // this.setState({ loading: true });
  //   // console.log("fetchPurchaseOrder", id);
  //   axios
  //     .get(`/purchaseOrders/${id}`)
  //     .then((res) => {
  //       const po = res.data;
  //       this.setState(
  //         {
  //           poNumber: po.poNumber,
  //           poDate: po.poDate,
  //           customerId: po.customerId,
  //           projectId: po.projectId,
  //           billingAddressId: po.billingAddressId,
  //           dispatchAddressId: po.dispatchAddressId,
  //           status: po.status,
  //           poItems: po.items.map((item) => ({
  //             serialNumber: item.serialNumber,
  //             itemId: item.itemId,
  //             hsnCode: item.hsnCode,
  //             uom: item?.uomData?.name || item.uom, // Get name from pre-fetched items
  //             quantity: item.quantity,
  //             rate: item.rate,
  //             taxableValue: item.taxableValue,
  //             gstValue: item.gstValue,
  //             totalValue: item.totalValue,
  //             pendingQuantity: item.pendingQuantity,
  //           })),
  //         },
  //         () => {
  //           this.fetchProjects(po.customerId);
  //           // this.fetchAddresses(po.customerId);
  //           this.fetchItems();
  //           this.fetchCustomersBillingAddress(po.customerId);
  //           this.fetchCustomersDispatchAddress(po.customerId);
  //           setTimeout(() => {
  //             this.setState({ loading: false })
  //           }, 3000)
  //         }
  //       );
  //     })
  //     .catch(() => {
  //       setTimeout(() => {
  //         this.setState({ loading: false })
  //       }, 1000)
  //     });
  // };


  fetchPurchaseOrder = async (id) => {
    // this.setState({ loading: true });
    try {
      const res = await axios.get(`/purchaseOrders/${id}`);
      const po = res.data;
      // Set form data from PO
      this.setState({
        poNumber: po.poNumber,
        poDate: po.poDate,
        customerId: po.customerId,
        projectId: po.projectId,
        billingAddressId: po.billingAddressId,
        dispatchAddressId: po.dispatchAddressId,
        status: po.status,
        poItems: po.items.map((item) => ({
          serialNumber: item.serialNumber,
          itemId: item.itemId,
          hsnCode: item.hsnCode,
          uom: item?.uomData?.name || item.uom,
          quantity: item.quantity,
          rate: item.rate,
          taxableValue: item.taxableValue,
          gstValue: item.gstValue,
          totalValue: item.totalValue,
          pendingQuantity: item.pendingQuantity,
        })),
      });

      // Wait for all dependent data to finish
      await Promise.all([
        this.fetchProjects(po.customerId),
        this.fetchItems(),
        this.fetchCustomersBillingAddress(po.customerId),
        this.fetchCustomersDispatchAddress(po.customerId),
      ]);
      this.setState({ showLoading: false })
    } catch (error) {
      console.error("Error fetching PO:", error);
      if (this.state.showLoading === false) {
        console.log("this.state.showLoading", this.state.showLoading)
        this.setState({ loading: false });
      } else {
        this.setState({ loading: false });
      }
    }
  };


  handleCustomerChange = (e) => {
    const customerId = e.target.value;
    this.setState(
      {
        customerId,
        projectId: "",
        billingAddressId: "",
        dispatchAddressId: "",
        projects: [],
        billingAddresses: [],
        dispatchAddresses: [],
      },
      () => {
        if (customerId) {
          this.fetchProjects(customerId);
          // this.fetchAddresses(customerId);
          this.fetchCustomersBillingAddress(customerId);
          this.fetchCustomersDispatchAddress(customerId);
        }
      }
    );
  };

  handleProjectChange = (e) => {
    this.setState({ projectId: e.target.value });
  };

  handleBillingAddressChange = (e) => {
    this.setState({ billingAddressId: e.target.value });
  };

  handleDispatchAddressChange = (e) => {
    this.setState({ dispatchAddressId: e.target.value });
  };

  handlePoNumberChange = (e) => {
    this.setState({ poNumber: e.target.value });
  };

  handlePoDateChange = (e) => {
    this.setState({ poDate: e.target.value });
  };

  handlePoItemChange = (index, field, value) => {

    const poItems = [...this.state.poItems];
    poItems[index][field] = value;

    if (field === "itemId") {
      const selectedItem = this.state.items.find((i) => i.itemid === parseInt(value));
      // const selectedItem = this.state.items.find((i) => i.name === parseInt(value));
      if (selectedItem) {
        poItems[index].hsnCode = selectedItem.hsnCode || "";
        poItems[index].uom = selectedItem.uomData?.name || ""; // Store UOM name
      } else {
        poItems[index].hsnCode = "";
        poItems[index].uom = "";
      }
    }

    if (field === "quantity" || field === "rate" || field === "itemId") {
      const quantity = parseFloat(poItems[index].quantity) || 0;
      const rate = parseFloat(poItems[index].rate) || 0;
      const taxableValue = quantity * rate;
      const gstValue = taxableValue * 0.18;
      const totalValue = taxableValue + gstValue;
      poItems[index].taxableValue = taxableValue;
      poItems[index].gstValue = gstValue;
      poItems[index].totalValue = totalValue;
      poItems[index].pendingQuantity = quantity; // Initially pending quantity equals quantity
    }

    this.setState({ poItems });
  };

  addRow = () => {
    const poItems = [...this.state.poItems];
    poItems.push({
      serialNumber: poItems.length + 1,
      itemId: "",
      hsnCode: "",
      uom: "",
      quantity: "",
      rate: "",
      taxableValue: 0,
      gstValue: 0,
      totalValue: 0,
      pendingQuantity: 0,
    });
    this.setState({ poItems });
  };

  removeRow = (index) => {
    const poItems = [...this.state.poItems];
    poItems.splice(index, 1);
    // Recalculate serial numbers
    poItems.forEach((item, idx) => {
      item.serialNumber = idx + 1;
    });
    this.setState({ poItems });
  };

  validateForm = () => {
    const errors = {};
    if (!this.state.customerId) errors.customerId = "Customer is required";
    if (!this.state.projectId) errors.projectId = "Project is required";
    if (!this.state.billingAddressId) errors.billingAddressId = "Billing address is required";
    if (!this.state.dispatchAddressId) errors.dispatchAddressId = "Dispatch address is required";
    // if (!this.state.poNumber.trim()) errors.poNumber = "PO Number is required";
    const poNumber = this.state.poNumber.trim();
    const poNumberRegex = /^\d{1,6}$/;

    if (!poNumber) {
      errors.poNumber = "PO Number is required";
    } else if (!poNumberRegex.test(poNumber)) {
      errors.poNumber = "PO Number must be 1 to 6 digits only";
    }
    if (!this.state.poDate) errors.poDate = "PO Date is required";
    this.state.poItems.forEach((item, index) => {
      if (!item.itemId) errors[`itemId_${index}`] = "Item is required";
      if (!item.quantity || item.quantity <= 0) errors[`quantity_${index}`] = "Quantity must be greater than 0";
      if (!item.rate || item.rate <= 0) errors[`rate_${index}`] = "Rate must be greater than 0";
    });
    return errors;
  };



  changeStatus = (newStatus) => {
    // debugger
    if (this.state.status === "pending") return;
    this.setState({ loading: true });

    const payload = {
      customerId: Number(this.state.customerId),
      projectId: Number(this.state.projectId),
      billingAddressId: Number(this.state.billingAddressId),
      dispatchAddressId: Number(this.state.dispatchAddressId),
      poNumber: this.state.poNumber,
      poDate: this.state.poDate,
      status: newStatus,  // The only changed field
      items: this.state.poItems.map(item => ({
        ...item,
        itemId: Number(item.itemId),
        serialNumber: Number(item.serialNumber),
        quantity: Number(item.quantity),
        rate: Number(item.rate),
        taxableValue: Number(item.taxableValue),
        gstValue: Number(item.gstValue),
        totalValue: Number(item.totalValue),
        pendingQuantity: Number(item.pendingQuantity),
      })),
    };
    axios
      // .put(`/purchaseOrders/${this.state.poId}`, { ...this.state, status: newStatus })
      .put(`/purchaseOrders/${this.state.poId}`, payload)
      .then(() => {
        this.setState({
          status: newStatus,
          loading: false,
          showToast: true,
          toastMessage: `Purchase Order status changed to ${newStatus}`,
          toastVariant: "success",
          color: 'green'
        });
        setTimeout(() => {
          this.setState({ loading: false })
        }, 1000)
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showToast: true,
          toastMessage: error.response?.data?.message || "Error changing status",
          toastVariant: "danger",
          color: 'red'
        });
        setTimeout(() => {
          this.setState({ loading: false })
        }, 1000)
      });
  };

  PurchaseOrderList = () => {
    this.props.history.push('/PurchaseOrderList')
  }

  render() {
    const {
      customers,
      projects,
      billingAddresses,
      dispatchAddresses,
      items,
      poNumber,
      poDate,
      customerId,
      projectId,
      billingAddressId,
      dispatchAddressId,
      status,
      poItems,
      errors,
      loading,
      isEdit,
    } = this.state;



    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={loading}>
          <div className="container-fluid pt-4">
            <Card>
              <Card.Header>
                <div className="purchase-order-back">
                  <b> View Purchase Order
                  </b>
                  <span style={{ cursor: 'pointer' }} onClick={() => this.PurchaseOrderList()}>
                    <i className="far fa-arrow-alt-circle-right"> Purchase Order List</i>
                  </span>
                </div>
              </Card.Header>
              <Card.Body>
                <Form>

                  <Row>
                    <Col md={3}>
                      <Form.Group controlId="formCustomer">
                        <Form.Label className="required">Customer</Form.Label>
                        <Form.Control
                          as="select"
                          value={customerId}
                          onChange={this.handleCustomerChange}
                          isInvalid={!!errors?.customerId}
                          disabled
                        >
                          <option value="">Select Customer</option>
                          {customers.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.name}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.customerId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formProject">
                        <Form.Label className="required">Project</Form.Label>
                        <Form.Control
                          as="select"
                          value={projectId}
                          onChange={this.handleProjectChange}
                          isInvalid={!!errors?.projectId}
                          disabled
                        >
                          <option value="">Select Project</option>
                          {projects.map((p) => (
                            <option key={p.id} value={p.id}>
                              {p.name}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.projectId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formPoNumber">
                        <Form.Label className="required">PO Number</Form.Label>
                        <Form.Control
                          type="text"
                          value={poNumber}
                          placeholder="Enter PO number"
                          onChange={this.handlePoNumberChange}
                          isInvalid={!!errors?.poNumber}
                          disabled
                        />
                        <Form.Control.Feedback type="invalid">{errors?.poNumber}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formPoDate">
                        <Form.Label className="required">PO Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={poDate}
                          onChange={this.handlePoDateChange}
                          isInvalid={!!errors?.poDate}
                          disabled
                        />
                        <Form.Control.Feedback type="invalid">{errors?.poDate}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group controlId="formBillingAddress">
                        <Form.Label className="required">Billing Address</Form.Label>
                        <Form.Control
                          as="select"
                          value={billingAddressId}
                          onChange={this.handleBillingAddressChange}
                          isInvalid={!!errors?.billingAddressId}
                          disabled
                        >
                          <option value="">Select Billing Address</option>
                          {this.state.customersBillingAddress.map((a) => (
                            <option key={a.id} value={a.id}>
                              {a.address}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.billingAddressId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="formDispatchAddress">
                        <Form.Label className="required">Dispatch Address</Form.Label>
                        <Form.Control
                          as="select"
                          value={dispatchAddressId}
                          onChange={this.handleDispatchAddressChange}
                          isInvalid={!!errors?.dispatchAddressId}
                          disabled
                        >
                          <option value="">Select Dispatch Address</option>
                          {this.state.customersDispatchAddress.map((a) => (
                            // {dispatchAddresses.map((a) => (
                            <option key={a.id} value={a.id}>
                              {a.address}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.dispatchAddressId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <h5>Items</h5>
                  {poItems.map((item, index) => (

                    <Card key={index} className="mb-3">
                      {
                        console.log("total value :", item.totalValue)
                      }
                      <Card.Body>
                        <Row>
                          <Col md={2}>
                            <Form.Group controlId={`formSno${index}`}>
                              <Form.Label>S.No</Form.Label>
                              <Form.Control type="text" value={item.serialNumber} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formItem${index}`}>
                              <Form.Label className="required">Item</Form.Label>
                              <Form.Control
                                as="select"
                                value={item.itemId}
                                onChange={(e) => this.handlePoItemChange(index, "itemId", e.target.value)}
                                isInvalid={!!errors?.[`itemId_${index}`]}
                                disabled
                              >
                                <option value="">Select Item
                                  {console.log("items", items)}
                                </option>
                                {items.map((i) => (
                                  <option key={i.itemid} value={i.itemid}>
                                    {i.name}
                                  </option>
                                ))}
                              </Form.Control>
                              <Form.Control.Feedback type="invalid">{errors?.[`itemId_${index}`]}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formHsnCode${index}`}>
                              <Form.Label>HSN Code</Form.Label>
                              <Form.Control type="text" value={item.hsnCode} readOnly placeholder="HSN code" />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formUom${index}`}>
                              <Form.Label>UOM</Form.Label>
                              <Form.Control type="text" value={item.uom} readOnly placeholder="UOM" />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formQuantity${index}`}>
                              <Form.Label className="required">PO Quantity</Form.Label>
                              <Form.Control
                                type="number"
                                value={item.quantity}
                                placeholder="Enter quantity"
                                onChange={(e) => this.handlePoItemChange(index, "quantity", e.target.value)}
                                isInvalid={!!errors?.[`quantity_${index}`]}
                                disabled
                                className="highlight-input"
                              />
                              <Form.Control.Feedback type="invalid">{errors?.[`quantity_${index}`]}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formRate${index}`}>
                              <Form.Label className="required">Rate</Form.Label>
                              <Form.Control
                                type="number"
                                value={item.rate}
                                placeholder="Enter rate"
                                onChange={(e) => this.handlePoItemChange(index, "rate", e.target.value)}
                                isInvalid={!!errors?.[`rate_${index}`]}
                                disabled
                              />
                              <Form.Control.Feedback type="invalid">{errors?.[`rate_${index}`]}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={2}>
                            <Form.Group controlId={`formTaxableValue${index}`}>
                              <Form.Label>Taxable Value</Form.Label>
                              <Form.Control type="number" value={item.taxableValue.toFixed(2)} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formGstValue${index}`}>
                              <Form.Label>GST (18%)</Form.Label>
                              <Form.Control type="number" value={item.gstValue.toFixed(2)} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formTotalValue${index}`}>
                              <Form.Label>Total Value</Form.Label>
                              <Form.Control type="number" value={item.totalValue.toFixed(2)} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formPendingQuantity${index}`}>
                              <Form.Label>Pending Quantity</Form.Label>
                              <Form.Control type="number" value={item.pendingQuantity} readOnly className="highlight-input" />
                            </Form.Group>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>

                  ))}
                </Form>
                <p className="total-value">Total Value of All Items: ₹ <span className="amount-value">{poItems.reduce((sum, item) => sum + (parseFloat(item.totalValue) || 0), 0).toFixed(2)}</span></p>
              </Card.Body>
            </Card>
          </div>
        </CommonLoader >
      </>
    );
  }
}
